<template>
  <div id="gfWrapper" class="relative">
    <div class="sticky h-10 bg-red-500">ok</div>
    <GfAlert
      v-if="alert.show"
      :first-title="alert.firstTitle"
      :alert-type="alert.typeAlert"
      :title="alert.title"
      :message="alert.message"
      :hide-close-icon="alert.hideCloseIcon" />
    <div id="gfFrameWrap">
      <LoadingContentEditor v-if="loadingContentEditor" />
      <div v-if="isRunningAbTest" class="ab-test__block-iframe"></div>
      <div v-if="isRunningAbTest" class="d-inline-flex align-items-stretch ab-test__warning-popup">
        <span class="ab-test__warning-line">&nbsp;</span>
        <div class="d-flex justify-content-between align-items-center ab-test__warning-main p-2">
          <div class="d-flex align-items-center">
            <span class="icon icon-warn-triangle text-black3 ab-test__warning-icon"></span>
            <p class="ab-test__warning-text pl-1">
              The content is not editable because this page is running A/B testing. You should pause this feature to
              continue editing.
            </p>
          </div>

          <a :href="runningCampaignLink" class="ab-test__campaign-link"> Open Campaign </a>
        </div>
      </div>
      <iframe
        id="gfFrame"
        ref="kekekeke"
        data-hj-allow-iframe="true"
        :data-shop="frameData.shop"
        :data-page="frameData.page"
        :data-title="frameData.title"
        :data-handle="frameData.handle"
        :data-meta="frameData.meta"
        :data-id="frameData.id"
        :data-type="frameData.type"
        :data-money="frameData.money"
        :data-published="frameData.published"
        :data-plan="frameData.plan"
        :data-shareable="frameData.shareable"
        :data-ref="frameData.ref"
        :data-lazyload="frameData.lazyload"
        :data-version="frameData.version" />
      <div v-if="isActive" id="gfFrameOverlay" />
    </div>

    <AllowAccessPasswordSticky v-if="enablePassword" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapGetters } from 'vuex';
import LoadingContentEditor from '@/views/GLoader/LoadingContentEditor.vue';
import AllowAccessPasswordSticky from '../AllowAccessPasswordSticky.vue';

const INFINITY_TIME = 999999;

export default defineComponent({
  name: 'GFrame',
  components: {
    LoadingContentEditor,
    AllowAccessPasswordSticky,
  },
  data: () => ({
    interval: -1,
    kekekeke: null,
  }),
  computed: {
    ...mapState('iframe', ['overlay', 'alert']),
    ...mapState('app', ['pageInfo', 'shopInfo', 'enablePassword']),
    ...mapState('page', {
      loadingContentEditor: 'loadingContentEditor',
    }),
    ...mapGetters('app', {
      isRunningAbTest: 'isRunningAbTest',
      runningCampaignId: 'runningCampaignId',
    }),
    runningCampaignLink() {
      return `/analytics/experiments/${this.runningCampaignId}`;
    },
    isActive() {
      return this.overlay;
    },
    frameData() {
      return {
        shop: this.shopInfo?.shopifyDomain || '',
        page: this.pageInfo?.page?.page || '',
        title: this.pageInfo?.page?.title || '',
        handle: this.pageInfo?.page?.handle || '',
        meta: this.pageInfo?.page?.meta || '',
        // eslint-disable-next-line camelcase
        id: this.pageInfo?.page?.g_id || '',
        type: this.pageInfo?.page?.type || '',
        // eslint-disable-next-line camelcase
        money: this.pageInfo?.currency_format || '',
        published: (this.pageInfo?.published || '') + '',
        plan: (this.pageInfo?.shareable || '') + '',
        shareable: this.shopInfo?.plan || '',
        ref: this.pageInfo?.ref || '',
        lazyload: (this.pageInfo?.lazyload || '') + '',
        version: '3.0',
      };
    },
  },
  watch: {
    alert(newValue) {
      if (newValue.show == true) {
        let delay = this.alert.delay || 2000;
        if (delay == 'infinity') {
          delay = INFINITY_TIME;
        }
        setTimeout(() => {
          this.alert.show = false;
        }, delay);
      }
    },
  },
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
#gfWrapper {
  display: table-cell;
  width: 100%;
  position: relative;
  z-index: 9999;
  padding-top: 44px;
  svg {
    display: inline;
    vertical-align: unset;
  }
}

#gfFrameWrap {
  position: fixed;
  top: $menu-size;
  right: 0;
  bottom: 0;
  left: auto;
  width: calc(100% - #{$sidebar-size});
  height: calc(100vh - #{$menu-size});
  z-index: 10000;
  overflow: hidden;

  .pointer {
    pointer-events: none;
  }

  background: $light2;
}

#gfFrameOverlay {
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  position: absolute;
}

#gfFrame {
  width: 100%;
  height: 100%;
  margin: 0px auto;
  border: none;
  display: block;
  background: $light1;
}
</style>
